import { cn } from '@/utils/cn';

/** Знак FoodCost Services (оранжевый квадрат с лепестками) — масштабируется без потери качества */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg viewBox="9 0 144 144" className={cn('h-8 w-8 shrink-0', className)} aria-hidden>
      <rect x="9" width="144" height="144" rx="36" fill="hsl(var(--brand))" />
      <rect x="9" width="144" height="144" rx="36" fill="url(#brand-mark-sheen)" />
      <g fill="#fff">
        <path
          opacity="0.5"
          d="M106.125 28.125C117.309 28.125 126.375 37.1912 126.375 48.375C126.375 59.5588 117.309 68.625 106.125 68.625H85.875L85.875 48.375C85.875 37.1912 94.9412 28.125 106.125 28.125Z"
        />
        <path
          opacity="0.95"
          d="M38.625 48.375C38.625 37.1912 47.6912 28.125 58.875 28.125C70.0588 28.125 79.125 37.1912 79.125 48.375V68.625H58.875C47.6912 68.625 38.625 59.5588 38.625 48.375Z"
        />
        <path
          opacity="0.82"
          d="M58.875 115.875C47.6912 115.875 38.625 106.809 38.625 95.625C38.625 84.4412 47.6912 75.375 58.875 75.375H79.125V95.625C79.125 106.809 70.0588 115.875 58.875 115.875Z"
        />
        <path
          opacity="0.82"
          d="M126.375 95.625C126.375 106.809 117.309 115.875 106.125 115.875C94.9412 115.875 85.875 106.809 85.875 95.625V75.375L106.125 75.375C117.309 75.375 126.375 84.4412 126.375 95.625Z"
        />
      </g>
      <defs>
        <linearGradient id="brand-mark-sheen" x1="81" y1="0" x2="81" y2="144" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" stopOpacity="0.16" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

/** Знак + название продукта */
export function BrandLogo({ collapsed, className }: { collapsed?: boolean; className?: string }) {
  return (
    <div className={cn('flex min-w-0 items-center gap-2.5', className)}>
      <BrandMark className="h-8 w-8 rounded-[9px] shadow-sm shadow-brand/30" />
      {!collapsed && (
        <div className="min-w-0 leading-tight">
          <div className="truncate text-sm font-semibold tracking-tight text-foreground">DF-UPR</div>
          <div className="truncate text-[11px] text-muted-foreground">FoodCost Services</div>
        </div>
      )}
    </div>
  );
}
